import { render, staticRenderFns } from "./SmallCarItinerary.vue?vue&type=template&id=094cb5fb&scoped=true&"
import script from "./SmallCarItinerary.vue?vue&type=script&lang=js&"
export * from "./SmallCarItinerary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "094cb5fb",
  null
  
)

export default component.exports